/**
 * Get Fleet Status Use Case
 * Fetches paginated machine list with filtering
 */

import { DashboardRepository } from '../data/dashboard-repository';
import { Machine } from '../types/dashboard-types';
import { MachineFilters } from '../types/filter-types';

export class GetFleetStatusUseCase {
  constructor(private readonly repository: DashboardRepository) {}

  async execute(
    page: number,
    pageSize: number,
    filters?: MachineFilters
  ): Promise<{
    machines: Machine[];
    totalCount: number;
    totalPages: number;
    hasError: boolean;
    errorMessage?: string;
  }> {
    try {
      const result = await this.repository.getFleetStatus(page, pageSize, filters);

      return {
        machines: result.machines,
        totalCount: result.totalCount,
        totalPages: Math.ceil(result.totalCount / pageSize),
        hasError: false,
      };
    } catch (error) {
      console.error('GetFleetStatusUseCase.execute failed:', error);

      return {
        machines: [],
        totalCount: 0,
        totalPages: 0,
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to load machines',
      };
    }
  }
}
